module.exports = __webpack_public_path__ + "img/list-variant-blue.e28d9be1.svg";